<template>
  <div class="c-app">
    <SubscriptionSidebar/>
    <CWrapper>
      <SubscriptionHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="slide">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <!--<TheFooter/>-->
      </div>
    </CWrapper>
  </div>
</template>

<script>
import SubscriptionSidebar from './SubscriptionSidebar'
//import TheFooter from './TheFooter'
import SubscriptionHeader from './SubscriptionHeader'


export default {
  name: 'SubscriptionContainer',
  components: {
    SubscriptionSidebar,
    //TheFooter,
    SubscriptionHeader,

  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
